// extracted by mini-css-extract-plugin
export default {"custom__input":"OrderCustomInput_custom__input__SzECh"};